import React, { useEffect, useState } from "react";

//PropTypes
import PropTypes from "prop-types";

//UI Material
import {
  Badge,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Popover,
  Stack,
  useMediaQuery,
} from "@mui/material";

//Local components
import Drawer from "./SwipeableDrawer";
import ElcoLogo from "../Logos/ElcoLogo";
import SnowAnimation from "../holidays/SnowAnimation";

//Material Icons
import {
  ArrowForwardIos,
  Menu,
  Notifications,
  NotificationsActive,
} from "@mui/icons-material";
import MenuIcon from "./MenuIcon";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";
import { typographyForCustomizedFontSize } from "../../Helpers/typography";

function AppViewport({ content }) {
  // ==========> Component States <==========
  //State for open the drawer component with the menu button
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Estado para controlar la activación de la nieve
  const [isSnowActive, setIsSnowActive] = useState(false);
  //Defines the min width screensize to phoneSize
  const phoneSize = !useMediaQuery("(min-width:600px");
  //State for tasks data
  const [data, setData] = useState([]);
  //State for the anchorEl of popover
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // ==========> Component Functions <==========
  //Function to handle click of button to open Popover
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  //Function to handle close of the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSnowToggle = (event) => {
    setIsSnowActive(event.target.checked);
  };

  /**
   * Function to generate the main menu button according to screen size
   * @returns the drawer menu button
   */
  const generateMenuButton = () => {
    if (phoneSize) {
      return <MenuIcon setOpen={setDrawerOpen} />;
    } else {
      return (
        <Button
          startIcon={<Menu />}
          variant="text"
          sx={{ color: "#000" }}
          onClick={setDrawerOpen}
        >
          {"Menú"}
        </Button>
      );
    }
  };

  //Function to get user's tasks
  const getUserTasks = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/tasks/get-user-tasks`,
        {}
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setData(
          jsonResponse.data.filter((task) => !task.completed && !task.canceled)
        );
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (e) {}
  };

  //The useEffect checks for token validation
  useEffect(() => {
    getUserTasks();
  }, []);

  //Function to generate the icon for notifications info
  const generateNotificationsIcon = (pendingTasks) => {
    return (
      <IconButton onClick={handleClick}>
        <Badge badgeContent={pendingTasks} color="warning">
          {pendingTasks > 0 ? (
            <NotificationsActive color="primary" />
          ) : (
            <Notifications />
          )}
        </Badge>
      </IconButton>
    );
  };

  //Function to generate the header of the viewport
  const generateHeader = () => {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: "100%" }}
      >
        <Grid
          item
          align="left"
          sx={{
            padding: "10px",
            borderRadius: "7px",
          }}
        >
          {generateMenuButton()}
        </Grid>
        <Grid item align="right">
          <Stack direction="row" alignItems="center" spacing={2}>
            {/*<FormControlLabel
              control={
                <Box display="flex" alignItems="center">
                  <Switch
                    checked={isSnowActive}
                    onChange={handleSnowToggle}
                    color="secondary"
                  />
                  <AcUnit style={{ marginLeft: 8 }} />
                </Box>
              }
            />*/}
            {generateNotificationsIcon(data.length)}
            <ElcoLogo height="40px" />
          </Stack>
        </Grid>
      </Grid>
    );
  };

  //Function to generate the popover structure
  const generatePopoverContent = (pendingTasks) => {
    if (pendingTasks > 0) {
      return (
        <Grid container sx={{ padding: "15px" }}>
          <Grid item xs={12}>
            {typographyForCustomizedFontSize(
              "Tienes tareas pendientes.",
              "11px"
            )}
          </Grid>
          <Grid item xs={12}>
            <Button
              size="small"
              color="secondary"
              endIcon={<ArrowForwardIos />}
              onClick={() => {
                window.location.href = "/tasks";
              }}
            >
              Ver tareas
            </Button>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid container sx={{ padding: "15px" }}>
          <Grid item xs={12}>
            {typographyForCustomizedFontSize(
              "No tienes tareas pendientes.",
              "11px"
            )}
          </Grid>
        </Grid>
      );
    }
  };

  // ==========> Component <==========
  return (
    <Box>
      <Drawer open={drawerOpen} setOpen={setDrawerOpen} />
      {isSnowActive && <SnowAnimation />}
      <Popover
        id={"user-tasks"}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {generatePopoverContent(data.length)}
      </Popover>
      <Grid container sx={{ padding: "10px" }}>
        {generateHeader()}
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2 }}>
          {content}
        </Grid>
      </Grid>
    </Box>
  );
}

AppViewport.propTypes = {
  content: PropTypes.element.isRequired,
};

export default AppViewport;
